export default __webpack_public_path__ + "pdf/LogHub - NAVOD NA POUZITIE.85f4d60d.pdf";